import {
  Configuration,
  LogLevel,
  PublicClientApplication,
} from "@azure/msal-browser";

/**
 * MSAL Configuration for Azure AD authentication
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_REACT_AZURE_APP_CLIENT_ID || "",
    authority: `https://login.microsoftonline.com/${
      import.meta.env.VITE_REACT_AZURE_APP_TENANT_ID
    }`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            // console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      logLevel:
        import.meta.env.MODE === "development" ||
        import.meta.env.MODE === "staging"
          ? LogLevel.Verbose
          : LogLevel.Warning,
    },
    allowNativeBroker: false,
  },
};

/**
 * Scopes for authentication requests. SharePoint/Graph calls no longer go
 * through the frontend (the BFF exchanges the API token for a delegated
 * Graph token on-behalf-of the user — see "SharePoint document library" in
 * knowledge_graph.md), so this no longer requests `Sites.ReadWrite.All`.
 */
export const loginRequest = {
  scopes: ["User.Read", "openid", "profile", "email"],
};

/**
 * Scopes for API access tokens
 */
export const apiRequest = {
  scopes: [
    `api://${import.meta.env.VITE_REACT_AZURE_APP_CLIENT_ID}/access_as_user`,
  ],
};

/**
 * MSAL Instance for token acquisition
 */
export const msalInstance = new PublicClientApplication(msalConfig);
